import Login from "pages/Auth/Login";
import Page404 from "pages/Page404";
import Home from "pages/Home/Home";
import Parks from "pages/Parks/Parks";
import Park from "pages/Parks/Park";
import Users from "pages/Users/Users";
import User from "pages/Users/User";
import MyAccount from "pages/Users/MyAccount";
import Support from "pages/Support/Support";
import ForgotPassword from "pages/Auth/ForgotPassword";
import ResetPassword from "pages/Auth/ResetPassword";
import Imports from "pages/Imports/Imports";
import Stats from "pages/Stats/Stats";
import Animals from "pages/Animals/Animals";
import Animal from "pages/Animals/Animal";
import AnimalDetail from "pages/Animals/AnimalDetail";
import ObservationGrids from "pages/ObservationGrids/ObservationGrids";
import ObservationGrid from "pages/ObservationGrids/ObservationGrid";
import Sectors from "pages/Sectors/Sectors";
import Sector from "pages/Sectors/Sector";
import Enclosures from "pages/Enclosure/Enclosures";
import Enclosure from "pages/Enclosure/Enclosure";
import ObservationGroups from "pages/ObservationGroups/ObservationGroups";
import ObservationGroup from "pages/ObservationGroups/ObservationGroup";
import Species from "pages/Species/Species";
import Specy from "pages/Species/Specy";
import Superfamily from "pages/Superfamily/Superfamily";
import Superfamilies from "pages/Superfamily/Superfamilies";
// import Genera from "pages/Genus/Genera";
// import Genus from "pages/Genus/Genus";
import Tags from "pages/Tags/Tags";
import Tag from "pages/Tags/Tag";
import History from "pages/History/History";
import ObservationResponses from "pages/ObservationResponses/ObservationResponses";
import ObservationResponse from "pages/ObservationResponses/ObservationResponse";
import TrainingExercises from "pages/TrainingExercises/TrainingExercises";
import TrainingExercise from "pages/TrainingExercises/TrainingExercise";
import BalanceSheets from "pages/BalanceSheets/BalanceSheets";
import SavedBalanceSheets from "pages/SavedBalanceSheets/SavedBalanceSheets";
import SavedBalanceSheet from "pages/SavedBalanceSheets/SavedBalanceSheet";
import ImportDetailList from "pages/Imports/detail/ImportDetailList";
import ImportDetailZims from "pages/Imports/detail/specific/ImportDetailZims";
import ImportDetailObservationGrid from "pages/Imports/detail/specific/ImportDetailObservationGrid";
import ImportDetailTraining from "pages/Imports/detail/specific/ImportDetailTraining";
import Servers from "pages/servers/Servers";
import Server from "pages/servers/Server";

const managers = ["SuperAdmin", "Admin"];
const pros = ["SuperAdmin", "Admin", "Manager", "Observer"];

const routes = [
  // others
  {
    path: "/users",
    roles: pros,
    managerRightsKey: "user",
    Component: Users,
  },
  {
    path: "/users/add",
    roles: pros,
    managerRightsKey: "user",
    Component: User,
  },
  {
    path: "/users/edit/:id",
    roles: pros,
    managerRightsKey: "user",
    Component: User,
  },
  { path: "/my-account", roles: pros, Component: MyAccount },

  // Animals
  {
    path: "/animals",
    roles: pros,
    managerRightsKey: "animal",
    Component: Animals,
  },
  {
    path: "/animals/add",
    managerRightsKey: "animal",
    roles: pros,
    Component: Animal,
  },
  {
    path: "/animals/edit/:id",
    managerRightsKey: "animal",
    roles: pros,
    Component: Animal,
  },
  {
    path: "/animals/:id",
    managerRightsKey: "animal",
    roles: pros,
    Component: AnimalDetail,
  },
  {
    path: "/species",
    managerRightsKey: "species",
    roles: pros,
    Component: Species,
  },
  {
    path: "/species/add",
    managerRightsKey: "species",
    roles: pros,
    Component: Specy,
  },
  {
    path: "/species/edit/:id",
    managerRightsKey: "species",
    roles: pros,
    Component: Specy,
  },

  {
    path: "/observation-groups",
    managerRightsKey: "observation-group",
    roles: pros,
    Component: ObservationGroups,
  },
  {
    path: "/observation-groups/add",
    managerRightsKey: "observation-group",
    roles: pros,
    Component: ObservationGroup,
  },
  {
    path: "/observation-groups/edit/:id",
    managerRightsKey: "observation-group",
    roles: pros,
    Component: ObservationGroup,
  },

  {
    path: "/superfamilies",
    roles: pros,
    managerRightsKey: "superfamily",
    Component: Superfamilies,
  },
  {
    path: "/superfamilies/add",
    roles: pros,
    managerRightsKey: "superfamily",
    Component: Superfamily,
  },
  {
    path: "/superfamilies/edit/:id",
    roles: pros,
    managerRightsKey: "superfamily",
    Component: Superfamily,
  },

  // {
  //   path: "/genera",
  //   roles: pros,
  //   managerRightsKey: "genus",
  //   Component: Genera,
  // },
  // {
  //   path: "/genera/add",
  //   roles: pros,
  //   managerRightsKey: "genus",
  //   Component: Genus,
  // },
  // {
  //   path: "/genera/edit/:id",
  //   roles: pros,
  //   managerRightsKey: "genus",
  //   Component: Genus,
  // },

  // Park
  { path: "/parks", roles: ["SuperAdmin"], Component: Parks },
  {
    path: "/parks/add",
    roles: ["SuperAdmin"],
    Component: Park,
  },
  {
    path: "/parks/edit/:id",
    roles: ["SuperAdmin"],
    Component: Park,
  },
  // Server
  { path: "/servers", roles: ["SuperAdmin"], Component: Servers },
  {
    path: "/servers/add",
    roles: ["SuperAdmin"],
    Component: Server,
  },
  {
    path: "/servers/edit/:id",
    roles: ["SuperAdmin"],
    Component: Server,
  },
  {
    path: "my-park",
    roles: pros,
    managerRightsKey: "myPark",
    Component: Park,
  },
  {
    path: "/sectors",
    managerRightsKey: "sector",
    roles: pros,
    Component: Sectors,
  },
  {
    path: "/sectors/add",
    managerRightsKey: "sector",
    roles: pros,
    Component: Sector,
  },
  {
    path: "/sectors/edit/:id",
    managerRightsKey: "sector",
    roles: pros,
    Component: Sector,
  },

  {
    path: "/enclosures",
    managerRightsKey: "enclosure",
    roles: pros,
    Component: Enclosures,
  },
  {
    path: "/enclosures/add",
    managerRightsKey: "enclosure",
    roles: pros,
    Component: Enclosure,
  },
  {
    path: "/enclosures/edit/:id",
    managerRightsKey: "enclosure",
    roles: pros,
    Component: Enclosure,
  },

  { path: "/support", roles: "all", Component: Support },
  {
    path: "/balance-sheets",
    roles: pros,
    managerRightsKey: "balance-sheet",
    Component: BalanceSheets,
  },
  {
    path: "/saved-balance-sheets",
    roles: pros,
    managerRightsKey: "balance-sheet",
    Component: SavedBalanceSheets,
  },
  {
    path: "/saved-balance-sheets/:id",
    roles: pros,
    managerRightsKey: "balance-sheet",
    Component: SavedBalanceSheet,
  },
  {
    path: "/observation-grids",
    roles: pros,
    managerRightsKey: "observation-grid",
    Component: ObservationGrids,
  },
  {
    path: "/observation-grids/add",
    roles: pros,
    managerRightsKey: "observation-grid",
    Component: ObservationGrid,
  },
  {
    path: "/imports",
    roles: pros,
    Component: Imports,
    managerRightsKey: "imports",
  },
  {
    path: "/imports/:id/animal/add",
    roles: pros,
    Component: ImportDetailZims,
  },
  {
    path: "/imports/:id/animal/:animalId/edit",
    roles: pros,
    Component: ImportDetailZims,
  },
  {
    path: "/imports/:id/observation-grids/add",
    roles: pros,
    Component: ImportDetailObservationGrid,
  },
  {
    path: "/imports/:id/training-exercises/add",
    roles: pros,
    Component: ImportDetailTraining,
  },
  {
    path: "/imports/:id",
    roles: pros,
    Component: ImportDetailList,
  },
  {
    path: "/observation-grids/edit/:id",
    managerRightsKey: "observation-grid",
    roles: pros,
    Component: ObservationGrid,
  },
  {
    path: "/observation-responses",
    roles: pros,
    Component: ObservationResponses,
  },
  {
    path: "/observation-responses/:id",
    roles: pros,
    Component: ObservationResponse,
  },
  {
    path: "/training-exercises",
    roles: pros,
    managerRightsKey: "training-grid",
    Component: TrainingExercises,
  },
  {
    path: "/training-exercises/add",
    roles: pros,
    managerRightsKey: "training-grid",
    Component: TrainingExercise,
  },
  {
    path: "/training-exercises/edit/:id",
    roles: pros,
    managerRightsKey: "training-grid",
    Component: TrainingExercise,
  },
  {
    path: "/history",
    roles: pros,
    Component: History,
    managerRightsKey: "history",
  },
  {
    path: "/tags",
    roles: pros,
    managerRightsKey: "tag",
    Component: Tags,
  },
  {
    path: "/tags/add",
    managerRightsKey: "tag",
    roles: pros,
    Component: Tag,
  },
  {
    path: "/tags/edit/:id",
    managerRightsKey: "tag",
    roles: pros,
    Component: Tag,
  },
  { path: "/imports", roles: ["SuperAdmin"], Component: Imports },
  {
    path: "/statistics",
    roles: managers,
    Component: Stats,
  },

  { path: "/", roles: "all", Component: Home },
  { path: "*", roles: "all", exact: false, Component: Page404 },
];

export const loginRoutes = [
  { path: "/login", roles: "all", Component: Login },
  { path: "/forgot-password", roles: "all", Component: ForgotPassword },
  { path: "/reset-password", roles: "all", Component: ResetPassword },
  { path: "/", roles: "all", Component: Login },
  { path: "*", roles: "all", exact: false, Component: Login },
];

export default routes;
